module.exports = __webpack_public_path__ + "img/icone-assistencia-funeral-familiar.c38f74d8.png";